module.exports = __webpack_public_path__ + "img/join-effect.f0fc8c59.svg";